if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) rootUrl = rootUrl + '/';

        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const sectionInnerHTML = doc.querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);
        const btn = this.querySelector('button');
        if (btn) btn.addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();

        const preview = sectionInnerHTML.querySelector('pickup-availability-preview');
        if (!preview) {
          // Nothing to show
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute('available', '');

        const newDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
        if (newDrawer) {
          document.body.appendChild(newDrawer);
          const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
          colorClassesToApply.forEach((colorClass) => {
            document.querySelector('pickup-availability-drawer').classList.add(colorClass);
          });

          const button = this.querySelector('button');
          if (button) {
            button.addEventListener('click', (evt) => {
              document.querySelector('pickup-availability-drawer').show(evt.target);
            });
          }
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        const closeBtn = this.querySelector('button');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => this.hide());
        }

        this.addEventListener('keyup', (event) => {
          if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target !== this &&
          !target.closest('pickup-availability-drawer') &&
          target.id !== 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        try { removeTrapFocus(this.focusElement); } catch (e) {}
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        try { trapFocus(this); } catch (e) {}
      }
    }
  );
}